var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSidebarLeft = function SvgSidebarLeft(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 15,
    "data-width-24": 23,
    viewBox: "0.65 2.15 16.7 13.7",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.5,
    height: 12.5,
    x: 1.25,
    y: 2.75,
    stroke: "currentColor",
    strokeWidth: 1.2,
    rx: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M6.5 3.25v11.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSidebarLeft);
export default ForwardRef;